import { Injectable } from '@angular/core';
import { Events, LoadingController, Platform } from 'ionic-angular';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { ConfigurationServices } from '../configuration/services';

@Injectable()
export class SearchReservationsServices {

  tables_search: any;
  tables_data: any;
  selectedTableId: any = '';
  show_list: any;
  tables: any;
  rooms: any;
  og: any;
  form: FormGroup;

  constructor(public events: Events,
    public loadingCtrl: LoadingController,
    public platform: Platform,
    public translate: TranslateService,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {

    this.passObservableToArray();

  }

  async passObservableToArray() {
    //Obtenemos los arrays
    this.tables = await this.configurationServices.getAllTypeTables();
  }

  async searchTable() {
    if (this.tables_data != undefined) {
      //Buscamos en el array de clientes si hay algun elemento que coincida con el input

      //Añadimos todos los nombres de clientes que contengan el input
      this.tables_search = this.tables.filter(item => item.name.toLowerCase().indexOf(this.tables_data.toLowerCase()) !== -1);

      //Añadimos todos los emails de clientes que contengan el input
      this.tables_search = this.tables_search.concat(this.tables.filter(item => item.room.toLowerCase().indexOf(this.tables_data.toLowerCase()) !== -1));

      //Eliminamos los elementos duplicados mirando el email del cliente
      this.tables_search = this.removeDuplicates(this.tables_search, 'UID');

      //Si el input tiene 2 o más caracteres mostramos la lista
      if (this.tables_search.length >= 2) {
        this.show_list = true;
      } else {
        this.show_list = false;
      }
    }
  }

  removeDuplicates(array, key) {
    let lookup = {};
    array.forEach(element => {
      lookup[element[key]] = element
    });
    return Object.keys(lookup).map(key => lookup[key]);
  };

  selectTable(table) {
    this.selectedTableId = table.UID;
    this.tables_data = table.room + " - " + table.name;
    this.show_list = false;
    this.form.get('UID_TABLE').setValue(table.UID);
    this.form.get('customer_table').setValue(table.room + " - " + table.name);
  }
}



// WEBPACK FOOTER //
// ./src/pages/services/searchsReservation.ts